import Shell from "../shell"

interface CountdownScreenProps {
    countdownNumber: number
}

const CountdownScreen = ({ countdownNumber }: CountdownScreenProps) => {
    return (
        <Shell>
            <div className="min-w-full my-auto flex items-center justify-center mt-[42px] min-h-full">
                <div className="text-[80px] font-bold my-auto text-onSurface-secondary leading-10">
                    {countdownNumber}
                </div>
                {/* Placeholder element for countdown position */}
                {/* <span className="w-[100%] mt-auto bg-transparent" /> */}
            </div>
        </Shell>
    )
}
export default CountdownScreen
